import React from "react";
import { useSelector } from "react-redux";
import { Action, ActionsPopup } from "../../../UI/ActionsPopup";
import Training from "./Training";
import classes from "./Trainings.module.css";

const Trainings = ({ filteredlist, handleEdit, handleDelete, view }) => {

    const { texts } = useSelector(state => state.translate);

    const handleClick = (id, link) => {
        if (view)
            window.open(link, '_blank', 'noopener,noreferrer')
        else
            handleEdit(id)
    }

    return <div className={classes.Trainings}>
        {filteredlist && filteredlist.map(t => <div key={t.id} className={classes.TrainingWrap}>
            {!view && <ActionsPopup>
                <Action onClick={() => handleEdit(t.id)}>{texts.edit} {texts.guidance}</Action>
                <Action onClick={() => handleDelete(t.id)}>{texts.delete} {texts.guidance}</Action>
            </ActionsPopup>}
            <Training
               
                url={t.url}
                description={t.description}
                name={t.name}
                img={`${t.baseUrl}/${t.thumbnail}`}
                {...t} onClick={() => handleClick(t.id, t.url)}></Training>
        </div>)}
    </div>

}
export default Trainings;